module.exports = __webpack_public_path__ + "static/img/banner_neural.b8c1e47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_neural.jpg
// module id = TVAE
// module chunks = 1